const STORAGE_KEY = 'ab-unsync-core-retry';

const listeners = new Set();
let snapshot = {
  jobId: readStoredJobId(),
  job: null,
};

function readStoredJobId() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || null;
  } catch (_) {
    return null;
  }
}

function writeStoredJobId(jobId) {
  try {
    if (jobId) sessionStorage.setItem(STORAGE_KEY, jobId);
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) { /* ignore */ }
}

function publish(next) {
  snapshot = next;
  listeners.forEach((listener) => listener(snapshot));
}

export function getCoreRetrySnapshot() {
  return snapshot;
}

export function subscribeCoreRetry(listener) {
  listeners.add(listener);
  listener(snapshot);
  return () => listeners.delete(listener);
}

export function publishCoreRetryJob(job) {
  const jobId = job?.jobId || null;
  const stillRunning = job?.status === 'running';
  writeStoredJobId(stillRunning ? jobId : null);
  publish({ jobId: stillRunning ? jobId : null, job: job || null });
}

export function clearCoreRetryJob() {
  writeStoredJobId(null);
  publish({ jobId: null, job: null });
}
